/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "common": {
            "nested": {
              "BusinessEntityType": {
                "values": {
                  "BET_DO_NOT_USE": 0,
                  "SOLE_PROPRIETORSHIP": 1,
                  "C_CORPORATION": 2,
                  "S_CORPORATION": 3,
                  "LIMITED_LIABILITY_COMPANY": 4,
                  "PARTNERSHIP": 5,
                  "COOPERATIVE": 6,
                  "INDEPENDENT_CONTRACTOR": 7,
                  "SELF_EMPLOYED": 8,
                  "NONPROFIT": 9,
                  "VETERANS_ORGANIZATION": 10,
                  "TRIBAL_BUSINESS": 11,
                  "OTHER": 12,
                  "CORPORATION": 13,
                  "INDIVIDUAL_SOLE_TRADER": 14,
                  "COMPANY": 15,
                  "INCORPORATED_ASSOCIATION": 16,
                  "UNINCORPORATED_ASSOCIATION": 17,
                  "GOVERNMENT_BODY": 18,
                  "UNIT_TRUST": 19,
                  "TRUST": 20,
                  "APPOINTOR_TRUST": 21,
                  "UNKNOWN_TRUST": 22,
                  "UNKNOWN": 23,
                  "JAPAN_COMPANY": 24
                }
              },
              "PaymentPeriod": {
                "values": {
                  "PP_DO_NOT_USE": 0,
                  "DAILY": 1,
                  "WEEKLY": 2,
                  "MONTHLY": 3
                }
              },
              "ProductName": {
                "values": {
                  "PN_DO_NOT_USE": 0,
                  "FLEX_LOAN": 1,
                  "MCA": 2,
                  "RISA": 3,
                  "MCA_GLOBAL": 4,
                  "LINE_OF_CREDIT": 5,
                  "BLENDED_LOAN": 6,
                  "TERM_LOAN": 7,
                  "MULTIDRAW_FLEX": 8
                }
              },
              "LoanDepositLocation": {
                "values": {
                  "LDL_DO_NOT_USE": 0,
                  "LINKED_BANK_ACCOUNT": 1,
                  "SQUARE_BALANCE": 2,
                  "SQUARE_CHECKING": 3
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.common?.nested?.BusinessEntityType && !$root.nested?.squareup?.nested?.capital?.nested?.common?.nested?.PaymentPeriod && !$root.nested?.squareup?.nested?.capital?.nested?.common?.nested?.ProductName && !$root.nested?.squareup?.nested?.capital?.nested?.common?.nested?.LoanDepositLocation) {
  $root.addJSON(jsonData);
}

/**
 * Entity types supported by Capital
 *
 * This list is enforced in Dashboard, within Capital's identity/claims
 * structure, and within financing Applications that support business entity types.
 *
 * SOURCE BusinessEntityType @ squareup/capital/common.proto at 12:1
 */
export const BusinessEntityType = $root.lookupEnum('squareup.capital.common.BusinessEntityType').values;
/**
 * Payment Periods supported by Capital
 *
 * This list is enforced in the Offer service
 *
 * SOURCE PaymentPeriod @ squareup/capital/common.proto at 60:1
 */
export const PaymentPeriod = $root.lookupEnum('squareup.capital.common.PaymentPeriod').values;
/**
 * Capital products from server
 *
 * SOURCE ProductName @ squareup/capital/common.proto at 101:1
 */
export const ProductName = $root.lookupEnum('squareup.capital.common.ProductName').values;
/**
 * Where a Capital loan is originated to. Used by capital (app-flow, servicing) & capital-frontend.
 *
 * SOURCE LoanDepositLocation @ squareup/capital/common.proto at 157:1
 */
export const LoanDepositLocation = $root.lookupEnum('squareup.capital.common.LoanDepositLocation').values;